export default {
  "home": "STARTSEITE",
  "news": "NEUIGKEITEN",
  "community": "COMMUNITY",
  "character": "CHARAKTERE",
  "world": "WELT EINSTELLUNGEN",
  "features": "FUNKTIONEN",
  "topUp": "AUFLADEN",
  "customerService": "KUNDENDIENST",
  "download": "DOWNLOAD",
  "moreDownload": "Weitere Download-Methoden",
  "screenshot": "SCREENSHOT",
  "video": "FILMISCH",
  "poster": "POSTER",
  "downloadGame": "DOWNLOAD",
  "scan": "Zum Download QR-Code scannen.",
  "prev": "Vorher",
  "next": "Nächstes",
  "moreNews": "INFORMATION",
  "latest": "NEUESTE",
  "fwtk": "NUTZUNGSBEDINGUNGEN",
  "yszc": "DATENSCHUTZ-BESTIMMUNGEN",
  "noContent": "Noch kein Inhalt",
  "goPay": "LOS GEHT‘S",
  "payGuide": "MEHR ERFAHREN",
  "stayTurn": "Bleib dran!",
  "huoyi": "Rote Feuerameise",
  "huoyi_text": "Die Feuerameise ist eine der berüchtigtsten invasiven Arten der Welt und für alle kleineren Ameisen gleichermaßen furchterregend.\r\nIm Gegensatz zu ihrer geringen Größe mit einer Gesamtlänge von 4-6 Millimeter, die sie harmlos erscheinen lassen, sind sie sehr aggressiv und zerstörerisch.",
  "huoyi_skill1": "Taktiken",
  "huoyi_skill2": "Schnelle Soldatin-LP",
  "huoyi_skill3": "Schnelle Soldatin-VTG",
  "huoyi_skill4": "Schnelle Soldatin-ANG ",
  "ciyi": "Bernsteinameise",
  "ciyi_text": "Polyrhachis trapezoidea, häufig in den offenen Eukalyptuswäldern und Savannenwäldern Australiens zu finden, haben goldene bis orangerote Borsten, die ihren Rücken bedecken.\r\nAn den Rändern ragen symmetrische, panzerartige Dornen hervor, der äußere Panzer ist hart und eine gute Verteidigung gegen Feinde.",
  "ciyi_skill1": "Taktiken",
  "ciyi_skill2": "Fernkampfsoldatin-LP",
  "ciyi_skill3": "Fernkampfsoldatin-VTG",
  "ciyi_skill4": "Fernkampfsoldatin-ANG ",
  "hongyi": "Fleischameise",
  "hongyi_text": "Monomorium sp, eine mysteriöse Art, die noch nicht genau benannt wurde, kann etwa 8 mm lang werden und hat einen sehr gut erkennbaren Blutfleck auf dem Rücken.",
  "hongyi_skill1": "Forschungsgeschwindigkeit",
  "hongyi_skill2": "Trainingsgeschwindigkeit",
  "hongyi_skill3": "Max. Armeeausmaß",
  "jinjia": "Erntearbeiterin",
  "jinjia_text": "Daceton armigerum, die in den Amazonas-Regenwäldern im Norden Südamerikas vorkommt, ist ein Fleischfresser.\r\nDie Größe dieser Ameisen variiert zwischen Arbeiterin- und Soldatenameisen, wobei die Soldatenameise bis zu 15-17 mm erreichen kann.\r\nIhre Ernährung ist sehr vielfältig, von einer Vielzahl von Insekten bis hin zu kleinen Schnecken.\r\nSie können ihre Beute nicht nur mit starken und kräftigen Zähnen zerreißen, sondern auch stechen und Gift injizieren, um die Beute besser zu zersetzen.",
  "jinjia_skill1": "Taktiken",
  "jinjia_skill2": "Nahkampfsoldatin-LP",
  "jinjia_skill3": "Nahkampfsoldatin-VTG",
  "jinjia_skill4": "Nahkampfsoldatin-ANG ",
  "gongbei": "Rossameise",
  "gongbei_text": "Camponotus mirabilis kommen nur in Teilen des nördlichen Südamerikas vor und werden als die Geister der Amazonas-Regenwälder bezeichnet.\r\nSie brüten normalerweise Blattläuse in den Bambusverbindungen, um Honigtau als Nahrung zu sammeln, aber gelegentlich jagen sie auch andere Insekten.",
  "gongbei_skill1": "Trainingsgeschwindigkeit",
  "gongbei_skill2": "Nahrungsanforderung fürs Training verringert",
  "gongbei_skill3": "Ausdauerkosten verringert",
  "specialAnt": "Spezial-Ameise",
  "back": "Zurück",
  "guide": "GUIDE",
  "announcement": "ANKÜNDIGUNG",
  "event": 'EVENT',
}
